import React from 'react';
import { Link } from 'react-router-dom';
import './BusinessOnboarding.css';

const BusinessOnboarding = ({ onOpenAuthModal }) => {
  return (
    <section className="business-onboarding-section" id="onboarding">
      <div className="jmi-container">
        <div className="onboarding-banner-box">
          <div className="banner-backdrop-pattern"></div>
          
          <div className="banner-content-top">
            <div className="section-label">PLATFORM ONBOARDING GATEWAY</div>
            <h2 className="banner-title">
              Ready to Join the <span className="gold-gradient-text">JMI Network?</span>
            </h2>
            <p className="banner-sub">
              Fast-track commercial verification with your trade credentials. 
              Users cannot self-register directly in-app — submit an official access request below to receive verified app access.
            </p>
          </div>

          <div className="banner-conversion-split">
            {/* For Buyers */}
            <div className="conversion-panel buyer-panel">
              <div className="panel-badge-row">
                <span className="panel-tag buyer-tag">FOR BUYERS & RETAILERS</span>
              </div>
              <h3 className="panel-title">Start sourcing jewellery through a structured B2B platform</h3>
              <p className="panel-desc">
                Procure hallmarked jewellery with precise weight breakdowns, live bullion pricing, 
                and verified transit custody directly to your retail establishment.
              </p>
              <div className="panel-perks">
                <span>✓ Zero Buyer Commission</span>
                <span>✓ BIS Hallmarked Quality</span>
                <span>✓ Digital Tax Invoicing</span>
              </div>
              <div className="panel-action">
                <button 
                  className="btn btn-lg w-full btn-buyer-red"
                  onClick={() => onOpenAuthModal ? onOpenAuthModal('buyer') : null}
                >
                  Apply for Buyer Access →
                </button>
                <Link to="/apply" className="panel-learn-more">
                  Or open dedicated full-page verification application
                </Link>
              </div>
            </div>

            {/* For Sellers */}
            <div className="conversion-panel seller-panel">
              <div className="panel-badge-row">
                <span className="panel-tag seller-tag">FOR MANUFACTURERS & WHOLESALERS</span>
              </div>
              <h3 className="panel-title">Put your jewellery business in front of B2B buyers</h3>
              <p className="panel-desc">
                Transform dead inventory into active revenue. Receive confirmed wholesale purchase orders 
                with automated payment reconciliations and secure courier pickups.
              </p>
              <div className="panel-perks">
                <span>✓ Pan-India Buyer Exposure</span>
                <span>✓ Real-time Inventory Locks</span>
                <span>✓ Fast Escrow Settlements</span>
              </div>
              <div className="panel-action">
                <button 
                  className="btn btn-outline-gold btn-lg w-full"
                  onClick={() => onOpenAuthModal ? onOpenAuthModal('seller') : null}
                >
                  Apply for Seller Access →
                </button>
                <Link to="/apply" className="panel-learn-more">
                  Or open dedicated full-page verification application
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessOnboarding;
